export const browserExtensions = [
  {
    title: 'Q: Does the extension work only on Chrome ?',
    text: 'A: Yes, the extension is designed for Chrome only at the moment. We hope to offer it for Mozilla over time',
  },
  {
    title: 'Q: Which Jobs boards is the extension compatible with ?',
    text: 'A:The Browser extension works with popular Job boards like Monster USA, Monster Europe, CareerBuilder, Dice, TechFetch, CW Jobs, Job Serve, Monster India and      Naukri.More are planned to be added soon.If you have request for a specific Job board write to us on support @wisestepmail.com',
  },
  {
    title: 'Q: How does the extension help me save Time and Money ?',
    text: 'A: The Extension allows you to capture Candidate information and preferences instantly from a Job board when you view a CV from the Job board.Just hit Save and you are done capturing all Candidate information and preferences with a single click. This helps you in many ways, you do not have to manually enter any data.You can create your Mappings, tear sheets or shortlists for any Job quickly.The Candidate information and profile captured Is available for you to search for re - use later.',
  },
  {
    title: 'Q: How can I search all my mapped Candidates ?',
    text: 'A: Candidate search provides Advanced Search Filters to make it easy to search on any criteria.',
  },
  {
    title: 'Q: I am facing some issues and My Browser extension is not working. Who can Help ?',
    text: 'A: If you have any issue on using the Browser extension you can click on the Report Issue link available in the Extension or write to us at support @wisestepmail.com with a screenshot',
  },
  {
    title: 'Q: Where can I see my Submitted Candidates ?',
    text: 'A: You can see all your Mapped and Submitted Candidates in the “Search Candidates Page under the Candidates Tab on the Menu',
  },
  {
    title: 'Q: Where can I see my Posted Jobs ?',
    text: 'A: You can see all your Posted Jobs in the under the Jobs Tab on the Menu',
  },
];

export const candidates = [
  {
    title: 'Q: What is a Candidates mapping and how does it help ?',
    text: 'A: The Candidate mapping page helps you organize your work better and record your conversations with Candidates to help understand their preferences leading to better engagement an overall better experience.',
    optionalText:
      'When you click on Add Candidate button on a Job record, you open the Mapping page for that Job. Candidate Mappings are also called Tearsheets.This is a list of Candidates who you consider speaking or contacting and making notes of their Preferences.Since there are many interactions between a Recruiter and a Candidate this page helps you keep track Conversations with Each Candidate',
  },
  {
    title: 'Q: Do I need to enter all the fields on the Candidate Mapping page ?',
    text: 'A: The short answer is No. You should enter as much information as you have or can get   in your conversations with the Candidates.',
    optionalText: '',
  },
  {
    title: 'Q: How can I Submit a Candidate to a Job ?',
    text: ' A: Use the Submit Candidate button to Submit Candidates from the Candidate Mapping sheet directly.If you want to submit a Candidate that is mapped, just click on“ Save and Start Submission” and it will take you to the“ Submit Candidate” Page ',
    optionalText:
      'Email address are retained so that if someone adds the Candidate again by mistake, they are reminded that the Candidate is on the delete list.',
  },
  {
    title: 'Q: How can I edit an already Submitted Candidate ?',
    text: 'A: On the submitted Candidate page for every Candidate record, you will find an edit button at the bottom of the record.Click on that to open the edit mode and update any information that you need to. Save to Submit the Candidate again.',
    optionalText: '',
  },
  {
    title: 'Q: Is there an easier way to add Candidate Data to the Candidate Mapping page ?',
    text: 'A: Yes, there is.Use our Chrome Browser Extension to instantly capture Data from Job boards and social networks like LinkedIn.This will prefill all the Candidate preferences in your Candidate mapping sheet.Get the Extension here',
    optionalText: '',
  },
  {
    title: 'Q: How do I send the Candidate Submission from Wisestep to my Email ?',
    text: 'A: On Submitted Candidates page, Use the Email button on the top right - hand corner to open a popup and send the submitted Candidate details to your self or to anyone else.',
    optionalText: '',
  },
  {
    title: 'Q: I am getting all the notifications and email from Recruiter@wisestepmail.com ?',
    text: 'A: The notifications sent by the Wisestep platform to you are sent from a Wisestep email domain.',
    optionalText: '',
  },
  {
    title: 'Q: Can I connect my email to my Wisestep account ?',
    text: 'A: We hope to offer this feature to you soon.',
    optionalText: '',
  },
  {
    title: 'Q: How do I Search My Submitted Candidates and Mapped Candidates ?',
    text: 'A: All your Mapped and Submitted Candidates are available under the Search Candidates page under the Candidates tab on the Menu.Use the Advanced search to find and map Candidates to Jobs',
    optionalText: '',
  },
  {
    title: 'Q: How do I update Candidate contact information ?',
    text: 'A: On Any Candidate Record in the Search Candidates Page click on More to open the right-hand panel to see the details of All the Conversations and Jobs Associated with a specific Candidate.You can update Candidate details from the Update button under the Candidate information box.',
    optionalText: '',
  },
];
export const dataPrivacy = [
  {
    title: 'Q: How do I manage Data Privacy of Candidates ?',
    text: 'A: Wisestep takes Data Privacy Seriously. All Candidates Records have Data Privacy options and you can mark Candidates to be added to the Resctrict List, Forget List or the Delete List.',
    optionalText: '',
  },
  {
    title: 'Q: What happens to Candidates in the Forget List ?',
    text: 'A: Candidates from the forget List will show up with just their Jobs contacted for details and No contact information visible.You cannot see any information for them or map them to any Job.',
    optionalText: '',
  },
  {
    title: 'Q: What happens to Candidates in the Delete List ?',
    text: 'A: Candidates from the Delete List will not show up in the Search and all their Contact information (except email address) along with “ Jobs contacted for”, CVs, Conversations are Deleted from the Wisestep platform.Any submissions made to clients are not deleted.',
    optionalText:
      'Email address are retained so that if someone adds the Candidate again by mistake, they are reminded that the Candidate is on the delete list.',
  },
  {
    title: 'Q: What happens to Candidates in the Restrict List ?',
    text: 'A: The Restrict list is a forget list with an end date. It behaves like a Forget list except that the Recruiter or the Candidate know that the Candidate will move back to a normal state once the end date is reached.During this time the Candidate contact   details and other contact information is not visible.',
    optionalText: '',
  },
  {
    title: 'Q:How do I remove Candidates from Forget, Restrict or Delete List',
    text: 'A: All Candidate records whether on the Mapping pages or Search Candidate pages have Data Privacy buttons.Click on the button and then select the“ Open for Communication”    option, specify your reason and enable the Candidate to be removed from the list.All  actions for this activity are logged so you always know which user did what.',
    optionalText: '',
  },
];
export const jobs = [
  {
    title:
      'Q: I posted my Job and have Candidate Submissions, but I forget to share `Job Management Rights` with my team. How can I do it Later ?',
    text: 'A: Once your Job is posted, you can click on the “Job Management Rights “and select a team to assign it to. You can also select if you want to apply these Job and Candidate management privileges to all prior Submitted Candidates and Candidate Mappings. With Job Management Rights shared, your team members can update, edit Statuses of Candidates Submitted to the Jobs.',
    optionalText: '',
  },
  {
    title: 'Q: I am unable to Edit a Job ?',
    text: 'A: You will be able to edit Jobs that are posted by you or for which you or your team has been provided Job Management Rights. If you are unable to edit a Job, then you should ask the person or team that assigned that Job to you. This can be found just below the Job with the following text “Assigned to you by X (Team Y) Z days ago”.',
    optionalText: '',
  },
  {
    title: 'Q:I am not able to create teams. What should I do ?',
    text: 'A: Team Creation privileges are not enabled by default. If you need to create teams write to us at support@wisestepmail.com for more details',
    optionalText: '',
  },
  {
    title: 'Q: What does assigning a Jobs to other Teams or Recruiters mean ?',
    text: 'A: Assigning a Job to other Teams or Recruiters means that you are inviting them to work on this open position and submit Candidates for this role. The “Assigned” Recruiters only have privileges to view the Job and Submit Candidates to it. They cannot update or edit the Job or update the Candidate status.',
    optionalText:
      ' Assigned Recruiters or Teams are different from the “Job Management Rights” that allow people to Edit, Manage, Close the Job and update the status of Submitted Candidates.',
  },
  {
    title: 'Q: How do I assign Jobs to other Teams and Recruiters mean ?',
    text: 'A: Once you complete posting your Job you will get an option to assign the Job to teams or individuals.',
    optionalText: '',
  },
  {
    title: 'Q: I forgot to Assign the Job once it was posted? How can I assign it ?',
    text: 'A: You can select the checkbox in front of the Job and click on “Assign Recruiters” button on the top and select teams or Recruiters from the list shown to you.',
    optionalText: '',
  },
  {
    title: 'Q: I just posted a Job. Can I assign the Job to anyone ?',
    text: 'A: You can assign Jobs to teams that are created by the same Team Owner. If you want to assign your Job to other people outside your company then write to us to become part of our partner program on partner@wisestepmail.com',
    optionalText: '',
  },
  {
    title: 'Q: I just posted a Job. Can I assign the Job to anyone ?',
    text: 'A: Wisestep takes Data Privacy Seriously. All Candidates Records have Data Privacy options and you can mark Candidates to be added to the Resctrict List, Forget List or the Delete List.',
    optionalText: '',
  },
  {
    title: 'Q: I am unable to update the status of Submitted Candidates ?"',
    text: 'A: You will be able to update the status of Candidates for which you or your team has been provided “Job Management Rights”. If you are unable to update the Candidate status, then you should ask the person or team that assigned that Job to you. This can be found just below the Job with the following text “Assigned to you by X (Team Y) Z days ago”.mation and profile captured Is available for you to search for re - use later.',
    optionalText: '',
  },
  {
    title: 'Q: How do I know that I can edit the Job or update Candidates submitted a Job ?',
    text: 'A: Below every Job Record, there are 2 types of messages “Job Posted by A (Team B) C days ago” OR“ Assigned to you by X(Team Y) Z days ago”.If you posted the Job or are part of the team that posted the Job, then you can“ Edit the Job” and“ Update Submitted Candidate Status”',
    optionalText: '',
  },
  {
    title: 'Q: How do I manage Data Privacy of Candidates ?',
    text: 'A: Wisestep takes Data Privacy Seriously. All Candidates Records have Data Privacy options and you can mark Candidates to be added to the Resctrict List, Forget List or the Delete List.',
    optionalText: '',
  },
  {
    title: 'Q: How can I see which teams I am part of ?',
    text: 'A: On the Top Menu look for the Teams Tab and under it click on the“ My Teams” link. This will show you the list of all the teams you are part of and the number of members of each team.',
    optionalText: '',
  },
  {
    title: 'Q: What happens to Candidates in the Delete List ?',
    text: 'A: Candidates from the Delete List will not show up in the Search and all their Contact information (except email address) along with “ Jobs contacted for”, CVs, Conversations are Deleted from the Wisestep platform.Any submissions made to clients are not deleted.',
    optionalText:
      'Email address are retained so that if someone adds the Candidate again by mistake, they are reminded that the Candidate is on the delete list.',
  },
  {
    title:
      'Q: How can I unsubscribe from certain types of notification emails like when a Job is posted, or shared, or a Candidate status is updated or submitted ?',
    text: 'A: In the Teams Section click on the“ Gears” icon that shows you the list of different notification events. You can click on“ Unsubscribe” on the ones you don’t want. You can“ Subscribe” to them again any time you want',
    optionalText: '',
  },
  {
    title: 'Q: Why do I have to assign Jobs to teams and not individuals ?',
    text: 'A: Wisestep works best when people are part of teams.Assigning Jobs to Individuals will be offered in the future.',
    optionalText: '',
  },
];
export const paymentIntegrationQueList = [
  {
    title: 'Q: What is Wisestep and how does the subscription work ?',
    text: 'A: Wisestep is a subscription-based ATS platform that offers recruitment and hiring solutions. With a Wisestep subscription, clients gain access to a variety of features',
    optionalText:
      'and tools to streamline their hiring process. The subscription is billed on a monthly/quarterly and annual basis.',
  },
  {
    title: 'Q: How can I buy a Wisestep subscription ?',
    text: 'A: To buy a Wisestep subscription, Go to our Pricing page and select the plan of your choice and proceed to the payment page.',
    optionalText: '',
  },
  {
    title: 'Q: How do I add users to my current Wisestep subscription?',
    text: 'A: You can log in to your Wisestep account. There you should navigate to the Menu → Pricing page. On the current plan Client will “Add Users”. Click on this button to add additional users and purchase. The system will calculate the prorated price and show it on the cart page.',
    optionalText:
      'Please note: Once the purchase is complete, the additional users are automatically added to the customers Wisestep account. An email will be sent to you for the plan upgrade with the invoice. Please note: The purchase process may take a few minutes to complete as the billing and API integrations are automated',
  },
  {
    title: 'Q: How is the pro-rated subscription charge calculated for added users ?',
    text: 'A: The prorated subscription charge for adding users will be included in your next billing cycle. When you receive your invoice for the upcoming billing period, it will reflect the prorated amount for the added users along with the regular subscription fee.',
    optionalText: '',
  },
  {
    title:
      'Q: How will I be billed in the next subscription cycle for the prorated subscription charge when adding users ?',
    text: 'A: The prorated subscription charge for adding users will be included in your next billing cycle. When you receive your invoice for the upcoming billing period, it will reflect the prorated amount for the added users along with the regular subscription fee.',
    optionalText: '',
  },
  {
    title: 'Q:  What happens if my subscription payment fails for any reason ?',
    text: 'A: If your subscription payment fails due to an expired card, insufficient funds, or any other reason, Stripe/Wisestep will notify you and attempt to retry the payment. You may need to update your payment information or resolve any issues with your payment method to ensure successful processing.',
    optionalText:
      'Wisestep will also provide support and guidance to assist you in resolving any payment-related issues.',
  },
  {
    title: 'Q: Can I cancel my Wisestep subscription and auto-payment arrangement ?',
    text: 'A: Yes, you can cancel your Wisestep subscription by writing to the Wisestep customer success team on support@wisestepmail.com',
    optionalText: '',
  },
  {
    title: 'Q:  What are all the payment methods supported by Stripe ?',
    text: 'A: Stripe accepts all popular cards issued by big networks like Visa, Mastercard, Amex, Discover, etc',
    optionalText: '',
  },
  {
    title: 'Q: What currencies are accepted for payment ?',
    text: 'A: We support USD, but customer accounts may be debited in the local currency based on the conversion rate applied by the bank.',
    optionalText: '',
  },
  {
    title: 'Q: Will I receive a receipt or invoice for my Wisestep subscription payments ?',
    text: 'A: Yes, after each successful payment, Our Payment partners Stripe/ Razorpay will send you a receipt via email, which serves as proof of your transaction.',
    optionalText:
      'You can also access your payment invoices on your Wisestep account by navigating to Menu → My Plans -> Invoices.',
  },
  {
    title:
      'Q: What should I do if I encounter any payment-related issues while using Stripe for my Wisestep subscription ?',
    text: 'A: If you experience any payment-related issues or have questions about your payment on Stripe, it is recommended to reach out to the Wisestep support team for assistance.',
    optionalText:
      'They will be able to provide guidance and help resolve any payment-related concerns.',
  },
  {
    title:
      'Q: What if I have additional questions or need support regarding my Wisestep subscription and payments ?',
    text: 'A: If you have any further questions or need support regarding your Wisestep subscription or payments, please do not hesitate to reach out to our customer support team.',
    optionalText:
      'You can contact us through at sales@wisestep-inc.com, and our team will be happy to assist you.',
  },
  {
    title: 'Q: Where will the customers see all the features of the plan assigned to them ?',
    text: 'A: Customers can see all the assigned features of their Plan on the my plan page. This is accessible from the Menu → Pricing → My Plan',
    optionalText: '',
  },
];

export const teamOwners = [
  {
    title: 'Q: What is a Team Owner and how does it help ?',
    text: 'A: Wisestep helps make recruiting more efficient for businesses. Businesses work in teams and Business owners can create teams on Wisestep to effectively replicate their organization on the Wisestep platform.',
  },
  {
    title: 'Q: Who should be interested in becoming a Team Owner ?',
    text: 'A: You should be looking at teams if you are any of the following Promoter, Business owner or CEO of a Recruitment Agency CHRO, Head of Human Resources, Head of Talent Acquisition for a Business CEO, Senior Business Leader in a business that is trying to scale their Hiring',
  },
  {
    title: 'Q: I am not able to create teams. What should I do ?',
    text: 'A: Team Creation privileges are not enabled by default. If you need to create teams  write to us at support@wisestepmail.com for more details',
  },
  {
    title: 'Q: How Many teams can I Create ?',
    text: 'A: If you have privileges to create a team, you can see then number of Teams and the maximum number of Team members that can be added under the“ My Teams” Link visible under the Teams Tab on the Menu',
  },
  {
    title: 'Q: How do I create my own workflow on Wisestep ?"',
    text: 'A: You can do this quite easily on the platform and get set up in minutes. However, to  get the right structure and flow in place, we would suggest you write to support @wisestepmail.com for a quick consultation',
  },
  {
    title: 'Q: How do I remove employees who have left our organization ?',
    text: 'A: Under the “Teams Created by Me” Section click on the person icon in front of a team to see the privileges to add or remove a team member.',
  },
  {
    title: 'Q: How do I disable emails for people who have left the company ?',
    text: 'A: Just remove them from all the teams they were part of.',
  },
  {
    title: 'Q: How do I deactivate accounts of people who have left the company ?',
    text: 'A: Under app settings page look for User Management Page, select the button to Edit user Privileges and Uncheck the Activation check box to deactivate the user.',
  },

  {
    title: 'Q: What is Data Sharing ?',
    text: 'A: Data sharing allows you to share Candidate data among teams within the same Team Owner. You can share the Candidate Mappings and the Search Candidates data among team for better collaboration between Teams. This option is available in App settings page.',
  },
  {
    title:
      'Q: When a team member is removed from a team, what happens to the data of the team member ?',
    text: 'A: If a team member is removed from a team, their data continues to remain with the team and is not deleted.',
  },
];
